function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    style: {
      "textIndent": 0,
      "textAlign": "start",
      "lineHeight": "normal",
      "textTransform": "none",
      "blockProgression": "tb",
      "InkscapeFontSpecification": "Sans"
    },
    d: "M 16 4 C 12.145852 4 9 7.1458513 9 11 C 9 13.377286 10.209548 15.48369 12.03125 16.75 C 7.9270676 18.351029 5 22.350074 5 27 L 7 27 C 7 22.600767 10.191695 18.926467 14.375 18.15625 L 15 20 L 17 20 L 17.625 18.15625 C 21.808305 18.926467 25 22.600767 25 27 L 27 27 C 27 22.350074 24.072932 18.351029 19.96875 16.75 C 21.790452 15.48369 23 13.377286 23 11 C 23 7.1458513 19.854148 4 16 4 z M 16 6 C 18.773268 6 21 8.2267317 21 11 C 21 13.773268 18.773268 16 16 16 C 13.226732 16 11 13.773268 11 11 C 11 8.2267317 13.226732 6 16 6 z M 15 21 L 14 27 L 18 27 L 17 21 L 15 21 z",
    color: "#000",
    overflow: "visible",
    fontFamily: "Sans"
  }));
};

export default __webpack_public_path__ + "static/media/manager.864da935.svg";
export { SvgComponent as ReactComponent };